module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_foodfly_m.08b4733a1d7607ff0c531f518fd48734.png";